import { useMemo } from 'react';

import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      wrapper: css`
        width: 100%;
        background-color: var(--common-color);
      `,

      container: css`
        ${responsive.create({
          maxWidth: {
            default: `${theme.spacing.get(768)}`,
            md: `${theme.spacing.get(1024)}`,
            lg: `${theme.spacing.get(1440)}`,
          },
          padding: {
            default: `${theme.spacing.get(56)} ${theme.spacing.get(16)}`,
            md: `${theme.spacing.get(70)} ${theme.spacing.get(24)}`,
            lg: `${theme.spacing.get(50)} ${theme.spacing.get(50)}`,
            xl: `${theme.spacing.get(100)} ${theme.spacing.get(100)}`,
          },
        })}
      `,

      title: css`
        font-weight: ${theme.fonts.weight.medium};
        text-align: center;
        color: var(--text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xl}`,
            md: `${theme.fonts.size.xxl}`,
            lg: `${theme.fonts.size['4xl']}`,
          },
        })}
      `,

      description: css`
        max-width: 680px;
        text-align: center;
        color: var(--desc-text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.sm}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
      `,

      headerSection: css`
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(36),
            md: theme.spacing.get(52),
            lg: theme.spacing.get(72),
          },
        })}
      `,

      cardsSection: css`
        width: 100%;
      `,

      cardGrid: css`
        display: grid;
        width: 100%;
        grid-auto-rows: 1fr;
        justify-content: center;

        ${responsive.create({
          gridTemplateColumns: {
            default: 'minmax(0, 1fr)',
            md: 'repeat(2, 330px)',
            lg: 'repeat(2, 450px)',
          },
          gap: {
            default: '24px',
            md: '32px',
          },
        })}
      `,

      cardGridItem: css`
        display: flex;
        width: 100%;
        height: 100%;
        min-width: 0;
        margin: 0 auto;

        ${responsive.create({
          maxWidth: {
            default: '100%',
            md: '330px',
            lg: '450px',
          },
        })}
      `,

      cardContainer: css`
        display: flex;
        width: 100%;
        height: 100%;
        background-color: var(--glow-card-bg);
        border-radius: 20px;
      `,

      cardBody: css`
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;

        ${responsive.create({
          padding: {
            default: `${theme.spacing.get(24)}`,
            md: `${theme.spacing.get(24)}`,
            lg: `${theme.spacing.get(36)}`,
          },
        })}
      `,

      cardWrapper: css`
        display: flex;
        flex: 1;
        width: 100%;
        min-width: 0;

        ${responsive.create({
          gap: {
            default: `${theme.spacing.get(16)}`,
            md: `${theme.spacing.get(16)}`,
            lg: `${theme.spacing.get(24)}`,
          },
        })}
      `,

      cardHeader: css`
        ${responsive.create({
          gap: {
            default: `${theme.spacing.add(12, 2)}`,
            md: `${theme.spacing.add(12, 2)}`,
            lg: `${theme.spacing.get(20)}`,
          },
        })}
      `,

      cardTitle: css`
        font-weight: ${theme.fonts.weight.semiBold};
        color: var(--text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.lg}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
      `,

      cardDescription: css`
        color: var(--desc-text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.sm}`,
            lg: `${theme.fonts.size.md}`,
          },
        })}
      `,
    }),
    [theme],
  );
};
